<template>
  <li>
    <router-link style="color: #ffffff" :to="{name: 'department', params: {'departmentSlug': department.slug }}">
      {$department.name}
    </router-link>
  </li>
</template>
<script>
  export default {
    name: 'departments-dropdown-item',
    props: {
      department: {
        type: Object,
        default: {}
      }
    }
  }
</script>